import { faro, LogLevel } from '@grafana/faro-web-sdk';
import type { EventSourceStatus } from '@vueuse/core';

export const SSE_LOST_MESSAGE = 'sse connection lost';

const SSE_STATUS_MESSAGES: Record<EventSourceStatus, string> = {
  CLOSED: 'sse connection closed',
  CONNECTING: 'sse connecting',
  OPEN: 'sse connection opened',
};

type SpanContext = { spanId: string; traceId: string };

const TRACEPARENT_PATTERN = /^[0-9a-f]{2}-([0-9a-f]{32})-([0-9a-f]{16})-[0-9a-f]{2}$/;

export function parseTraceparent(traceparent: string): SpanContext | undefined {
  const match = TRACEPARENT_PATTERN.exec(traceparent);
  return match ? { spanId: match[2], traceId: match[1] } : undefined;
}

export type SseLogger = {
  onStatus(status: EventSourceStatus, error: Event | null): void;
  onTrace(traceparent: string): void;
};

export function sseLogger(url: string): SseLogger {
  let spanContext: SpanContext | undefined;

  function push(message: string, level: LogLevel): void {
    faro.api.pushLog([message], { context: { url }, level, skipDedupe: true, spanContext });
  }

  return {
    onStatus(status, error) {
      if (status === 'OPEN') return;

      const lost = status === 'CLOSED' && error !== null;
      push(lost ? SSE_LOST_MESSAGE : SSE_STATUS_MESSAGES[status], lost ? LogLevel.WARN : LogLevel.DEBUG);
      if (status === 'CONNECTING') spanContext = undefined;
    },
    onTrace(traceparent) {
      spanContext = parseTraceparent(traceparent);
      push(SSE_STATUS_MESSAGES.OPEN, LogLevel.DEBUG);
    },
  };
}
